import React, { useState } from "react";
import Chatbox from "../box-chat";
import useAppAccessor from "../../../../hooks/useappAccessor";
import _ from "lodash";
import { getBrandColor } from "../../../../utils/brand.util";

const ActivityChat = () => {
  const { getInteractions } = useAppAccessor();
  const { activityInteractionData } = getInteractions();
  const { getUserData } = useAppAccessor();
  const { language, client } = getUserData();

  const truncateFullName = (firstName:any, lastName:any) => {
    if (firstName && lastName) {
      const datafirstName = firstName.split(" ");
      const datalastName = lastName.split(" ");
      return datalastName[datalastName.length - 1] + " " + datafirstName[0];
    } else {
      return;
    }
  };


  return (
    <div
    style={{
      maxHeight: "80vh",
      overflowX: "hidden",
      overflowY: "auto",
    }}
    >
      {/* {
       activityInteractionData.map((data:any,index:any)=>{
         return(
          <div>
      <div className="flex flex-row pl-2 pr-2 mt-3" key={index}>
        <div className="flex rounded-full h-[45px] w-[45px] min-w-[45px] min-h-[45px] items-center justify-center mr-3">
          {
            data?.from?.avatar && data?.from?.avatar.length > 0 ? <img style={{borderRadius:'50%'}} src={data?.from?.avatar} /> : <span className="text-white">{Array.from(data?.from?.firstName)[0]+''+Array.from(data?.from?.lastName)[0]}</span>
          }
          
        </div>

       <div className="flex flex-col p-4 rounded">
         <span className="text-white text-xs font-semibold">{data?.from?.firstName+' '+data?.from.lastName}</span>
         <span className="text-white text-xs font-semibold">{data?.text}</span>
        </div>

        
      </div>
      <div className="ml-2 mr-2" style={{ marginTop:'10px', height: '0.5px', backgroundColor:'#eeeeee', opacity: 0.5}} />

         
         </div>
         )
      })
      
    } */}

      {
        //  tempArray.map((data:any,index:any)=>{
        activityInteractionData.map((data: any, index: any) => {
          return (
            <div>
              <div className="flex flex-row pl-2 pr-2 mt-3" key={index}>
                <div 
                style={{backgroundColor: getBrandColor(client)}}
                className="flex rounded-full h-[45px] w-[45px] min-w-[45px] min-h-[45px] items-center justify-center">
                  {data?.from?.avatar && data?.from?.avatar.length > 0 &&
                  !data?.from?.avatar.includes("default_avatar.png") ? (
                    <img
                      style={{ borderRadius: "50%" }}
                      src={data?.from?.avatar}
                    />
                  ) : (
                    <span className="text-base text-white font-medium">
                    {data?.from?.firstName && data?.from?.lastName ? (
                      `${Array.from(data.from.firstName)[0] || ''}${Array.from(data.from.lastName)[0] || ''}`
                    ) : (
                      'N/A' // Fallback in case firstName or lastName is not available
                    )}
                    </span>
                  )}
                </div>
                <div className="flex flex-col pl-3 pt-2">
                  <span className="text-white text-xs font-semibold"> 
                    {data.from.firstName + ' ' + data.from.lastName}
                  </span>
                  <span
                    className="text-[#eeeeee] text-xs "
                    style={{ opacity: 0.7 }}
                  >
                    {data.from.firstName + ' ' + data.from.lastName + " "}
                    {language["has_joined"]}
                  </span>
                </div>
              </div>
              <div
                className="ml-2 mr-2"
                style={{
                  marginTop: "10px",
                  height: "0.5px",
                  backgroundColor: "#eeeeee",
                  opacity: 0.5,
                }}
              />
            </div>
          );
        })
      }
    </div>
  );
};

export default ActivityChat;
